import { getOrdinal } from 'Utilities/formatter';

export const formatDate = (dateString?: string): string | undefined => {
  if (!dateString) {
    return undefined;
  }

  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) {
    return undefined;
  }

  const day = date.getDate();
  const month = new Intl.DateTimeFormat('en-GB', { month: 'long' }).format(date);
  const year = date.getFullYear();

  return `${getOrdinal(day)} ${month} ${year}`;
};
